import { render, staticRenderFns } from "./learn_record.vue?vue&type=template&id=70a4f771&scoped=true&"
import script from "./learn_record.vue?vue&type=script&lang=js&"
export * from "./learn_record.vue?vue&type=script&lang=js&"
import style0 from "./learn_record.vue?vue&type=style&index=0&id=70a4f771&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a4f771",
  null
  
)

export default component.exports